import { SQL_DATE_FORMAT } from 'api/api.constant';
import { format } from 'date-fns';

export const formatSQLDate = (date: Date): string =>
  format(date, SQL_DATE_FORMAT);
